import h from 'virtual-dom/h';
import TimestampRenderer from "./timestamp-renderer";
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {VChild} from "virtual-dom";
import {HistoryMessage} from "../../../../types/history";
import {HistoryMessageLiveChatInput} from "../models/HistoryMessages";


export default class InputRenderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _timeStamp: TimestampRenderer;
    _timeStampRenderer: (message: HistoryMessage) => VChild;
    
    
    //#region Public Interface
    
    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
        this._timeStamp = new TimestampRenderer(this._settings.classNames.livechat.timestampInputClassName, this._settings.livechat.shouldDisplayTimestamp);
        this._timeStampRenderer = this._timeStamp.getRender();
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessageLiveChatInput): boolean
    {
        return message.type === this._settings.messageConstants.livechatInputType
            && !!message?.maskedInput;
    }

    getRenderer()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message as HistoryMessageLiveChatInput)) { return []; }

            const userName = this._settings.textConstants.userDisplayName;
            const { inputDisplayName, inputText, inputMessage, inputPersonaIcon, inputContainer } = this._settings.classNames.livechat;

            const inputName = h('div', { className: inputDisplayName }, userName);
            const text = h('div', { className: inputText }, (message as HistoryMessageLiveChatInput).maskedInput);
            const inputMessageNode = h('div', { className: inputMessage, tabIndex:0 }, [inputName, text]);
            const persona = h('div', { className: inputPersonaIcon }, []);
            const timeStamp = this._timeStampRenderer(message);

            return h('div', { className: inputContainer }, [inputMessageNode, persona, timeStamp]);
        };
    }
    
    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/input-renderer.ts